var map = {
	"./Banner0.webp": 94626,
	"./Banner0iPad.webp": 74833,
	"./Banner1.webp": 56958,
	"./Banner1iPad.webp": 22144,
	"./Banner2.webp": 19695,
	"./Banner2iPad.webp": 80641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32265;